<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Изображения по умолчанию</strong>
                </CCardHeader>
                <CCardBody>
                    <CRow><CCol tag="label" class="col-form-label">Лейблы</CCol></CRow>
                    <CForm style="margin-left: 50px">
                    <!-- for is new -->
                    <CRow>
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label font-bold">
                            Новый сервис
                        </CCol>
                    </CRow>
                    <div style="margin-left: 50px">
                        <CRow v-if="images.is_new_label_picture">
                            <CCol sm="3" class="col-form-label">&nbsp;</CCol>
                            <CCol sm="9" class="col-form-label">
                                <CImg
                                    :src="newLabelPictureUrl"
                                    class="m2"
                                    width="100" />
                            </CCol>
                        </CRow>
                        <CInputFile
                            ref="picture"
                            label="Изображение для лейбла (новые сервисы)"
                            horizontal
                            @change="selectNewLabelPicture" />  
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Угол</CCol>
                            <CCol sm="4">
                                <CSelect
                                    inline
                                    :value.sync="images.is_new_label_side"
                                    :options="services_label_side"
                                    placeholder="Угол..."
                                />
                            </CCol>
                        </CRow>
                    </div>
                    <!-- for is vegan -->
                    <CRow>
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label font-bold">
                            Веган
                        </CCol>
                    </CRow>
                    <div style="margin-left: 50px">
                        <CRow v-if="images.vegan_label_picture">
                            <CCol sm="3" class="col-form-label">&nbsp;</CCol>
                            <CCol sm="9" class="col-form-label">
                                <CImg
                                    :src="veganLabelPictureUrl"
                                    class="m2"
                                    width="100" />
                            </CCol>
                        </CRow>
                        <CInputFile
                            ref="picture"
                            label="Изображение для лейбла (новые сервисы)"
                            horizontal
                            @change="selectVeganLabelPicture" />  
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Угол</CCol>
                            <CCol sm="4">
                                <CSelect
                                    inline
                                    :value.sync="images.vegan_label_side"
                                    :options="services_label_side"
                                    placeholder="Угол..."
                                />
                            </CCol>
                        </CRow>
                    </div>
                    <!-- for is verified -->
                    <CRow>
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label font-bold">
                            Проверено МИРСИТИ
                        </CCol>
                    </CRow>
                    <div style="margin-left: 50px">
                        <CRow v-if="images.is_new_label_picture">
                            <CCol sm="3" class="col-form-label">&nbsp;</CCol>
                            <CCol sm="9" class="col-form-label">
                                <CImg
                                    :src="verifiedLabelPictureUrl"
                                    class="m2"
                                    width="100" />
                            </CCol>
                        </CRow>
                        <CInputFile
                            ref="picture"
                            label="Изображение для лейбла (новые сервисы)"
                            horizontal
                            @change="selectVerifiedLabelPicture" />  
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Угол</CCol>
                            <CCol sm="4">
                                <CSelect
                                    inline
                                    :value.sync="images.verified_mircity_label_side"
                                    :options="services_label_side"
                                    placeholder="Угол..."
                                />
                            </CCol>
                        </CRow>
                    </div>
                    </CForm>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="save"
                    >Сохранить</CButton
                    >
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack"
                    >Отмена</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import { BUSINESS_TYPE } from '@/utils/order';
    import { BUSINESS_LABEL_SIDE } from '@/utils/servicesLabel'
    

    export default {
        name: 'EntityImages',

        data() {
            return {
                services_label_side: null,
                images: {
                    product_palceholder: '',
                    is_new_label_picture: '',
                    vegan_label_picture: '',
                    verified_mircity_label_picture: '',
                    is_new_label_side: '',
                    vegan_label_side: '',
                    verified_mircity_label_side: '',
                },
                selectedPicture: null,
                selectedPictureIsNewLabel: null,
                selectedPictureVeganLabel: null,
                selectedPictureVerifiedLabel: null,
            };
        },

        computed: {
            pictureUrl() {
                if (this.images.product_palceholder) {
                    return (
                        process.env.VUE_APP_STATIC_BASE_URL +
                        '/' +
                        this.images.product_palceholder
                    );
                } else {
                    return '';
                }
            },
            newLabelPictureUrl() {
                if (this.images.is_new_label_picture) {
                    return process.env.VUE_APP_STATIC_BASE_URL + '/' + this.images.is_new_label_picture;
                }
                return '';
            },
            veganLabelPictureUrl() {
                if (this.images.vegan_label_picture) {
                    return process.env.VUE_APP_STATIC_BASE_URL + '/' + this.images.vegan_label_picture;
                }
                return '';
            },
            verifiedLabelPictureUrl() {
                if (this.images.verified_mircity_label_picture) {
                    return process.env.VUE_APP_STATIC_BASE_URL + '/' + this.images.verified_mircity_label_picture;
                }
                return '';
            },
        },

        async mounted() {
            const data = (await this.axios.get(`/default-settings/images/${BUSINESS_TYPE.ENTITY}`)).data;
            if (data?.id) {
                this.images = data;
            }
            if(!this.services_label_side) {
                const labelsSide = [];
                labelsSide.push({ value: BUSINESS_LABEL_SIDE.TOP_RIGHT, label: 'Правый верхний угол' });
                labelsSide.push({ value: BUSINESS_LABEL_SIDE.TOP_LEFT, label: 'Левый верхний угол' });
                labelsSide.push({ value: BUSINESS_LABEL_SIDE.BOTTOM_RIGHT, label: 'Нижний правый угол' });
                labelsSide.push({ value: BUSINESS_LABEL_SIDE.BOTTOM_LEFT, label: 'Нижний левый угол' });
                labelsSide.push({ value: null, label: 'Отключен' });
                this.services_label_side = labelsSide;
            }
        },

        methods: {
            selectPicture(FileList) {
                this.selectedPicture = FileList[0];
            },
            selectNewLabelPicture(FileList) {
                this.selectedPictureIsNewLabel = FileList[0];
            },
            selectVeganLabelPicture(FileList) {
                this.selectedPictureVeganLabel = FileList[0];
            },
            selectVerifiedLabelPicture(FileList) {
                this.selectedPictureVerifiedLabel = FileList[0];
            },
            async save() {
                try {
                    let formData = new FormData();
                    if (this.selectedPicture) {
                        formData.append('file', this.selectedPicture);
                        const pictureName = await Vue.axios.post('/files/upload', formData);
                        this.images.product_palceholder = pictureName.data.filename;
                    }

                    if (this.selectedPictureIsNewLabel) {
                        let formData = new FormData();
                        formData.append('file', this.selectedPictureIsNewLabel);
                        const pictureName = await Vue.axios.post('/files/upload', formData);
                        this.images.is_new_label_picture = pictureName.data.filename;
                    }

                    if (this.selectedPictureVeganLabel) {
                        let formData = new FormData();
                        formData.append('file', this.selectedPictureVeganLabel);
                        const pictureName = await Vue.axios.post('/files/upload', formData);
                        this.images.vegan_label_picture = pictureName.data.filename;
                    }

                    if (this.selectedPictureVerifiedLabel) {
                        let formData = new FormData();
                        formData.append('file', this.selectedPictureVerifiedLabel);
                        const pictureName = await Vue.axios.post('/files/upload', formData);
                        this.images.verified_mircity_label_picture = pictureName.data.filename;
                    }
                    this.images.entity_type = BUSINESS_TYPE.ENTITY;
                    await this.axios.post('/default-settings/images/', this.images);

                    this.goBack();
                } catch (error) {
                    this.$root.$emit('showError', 'Ошибка сохранения.');
                }
            },

            goBack() {
                this.$router.push({ path: '/settings/entities' });
            },
        },
    };
</script>
